import { render, staticRenderFns } from "./BladeDataSourceEdit.vue?vue&type=template&id=2f4b9132&"
import script from "./BladeDataSourceEdit.vue?vue&type=script&lang=ts&"
export * from "./BladeDataSourceEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
